import { collectEffectivePackageTypeIds } from "@src/common/utils/filterVehicleTypesByEffectivePackageTypes";

interface NamedPackageType {
  id: string;
  name: string;
}

interface PackageItemTypeOverride {
  packageTypeId?: string | null;
}

export interface EffectivePackageTypeNamePart {
  id: string;
  name: string;
  isShipmentType: boolean;
}

/**
 * Distinct effective type names for the orders table: shipment type plus
 * each item's effective type (override ?: shipment type).
 */
export function effectivePackageTypeNameParts(
  shipmentPackageType: NamedPackageType | null | undefined,
  packageItems: PackageItemTypeOverride[] | null | undefined,
  packageTypes: NamedPackageType[],
): EffectivePackageTypeNamePart[] {
  const namesById = new Map<string, string>(
    packageTypes.map((packageType: NamedPackageType) => [
      packageType.id,
      packageType.name,
    ]),
  );
  if (shipmentPackageType) {
    namesById.set(shipmentPackageType.id, shipmentPackageType.name);
  }
  const shipmentTypeId: string | undefined = shipmentPackageType?.id;

  return collectEffectivePackageTypeIds(shipmentPackageType?.id, packageItems)
    .map((id: string) => {
      const name: string | undefined = namesById.get(id);
      if (!name) return null;
      const part: EffectivePackageTypeNamePart = {
        id,
        name,
        isShipmentType: id === shipmentTypeId,
      };
      return part;
    })
    .filter((part): part is EffectivePackageTypeNamePart => part != null);
}

export function formatEffectivePackageTypeNames(
  shipmentPackageType: NamedPackageType | null | undefined,
  packageItems: PackageItemTypeOverride[] | null | undefined,
  packageTypes: NamedPackageType[],
): string {
  return effectivePackageTypeNameParts(
    shipmentPackageType,
    packageItems,
    packageTypes,
  )
    .map((part: EffectivePackageTypeNamePart) => part.name)
    .join(", ");
}
